import React from "react";
import { Link } from "react-router-dom";
function BlogWrapper() {
  return (
    <div>
      <section className="blog-section dark-style">
        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-7">
              <div className="section-heading text-center">
                <div className="sub-title text-white justify-content-center">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Our Blog
                </div>
                <h2 className="text-white">Latest News & Articles</h2>
              </div>
            </div>
          </div>

          <div className="row g-4">
            {/* Blog Card */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="blog-card style-three dark-style">
                <img src="assets/img/bg-img/47.jpg" alt="" />
                <div className="p-4">
                  <div className="blog-meta mt-0 d-flex align-items-center gap-2">
                    <Link to="#">Knowledge</Link>
                    <div className="dot"></div>
                    <Link to="#">26 June 2024</Link>
                  </div>
                  <Link className="post-title mb-3" to="/blogdetails">
                    A Guide to Practicing Law in Multiple States
                  </Link>
                  <Link to="/blogdetails" className="btn btn-link">
                    {" "}
                    Read More <i className="ti ti-arrow-up-right"></i>
                  </Link>
                </div>
              </div>
            </div>

            {/* Blog Card */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="blog-card style-three dark-style">
                <img src="assets/img/bg-img/48.jpg" alt="" />
                <div className="p-4">
                  <div className="blog-meta mt-0 d-flex align-items-center gap-2">
                    <Link to="#">Knowledge</Link>
                    <div className="dot"></div>
                    <Link to="#">26 June 2024</Link>
                  </div>
                  <Link className="post-title mb-3" to="/blogdetails">
                    How to Successfully Organize Your Legal Files
                  </Link>
                  <Link to="/blogdetails" className="btn btn-link">
                    {" "}
                    Read More <i className="ti ti-arrow-up-right"></i>
                  </Link>
                </div>
              </div>
            </div>

            {/* Blog Card */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="blog-card style-three dark-style">
                <img src="assets/img/bg-img/49.jpg" alt="" />
                <div className="p-4">
                  <div className="blog-meta mt-0 d-flex align-items-center gap-2">
                    <Link to="#">Knowledge</Link>
                    <div className="dot"></div>
                    <Link to="#">26 June 2024</Link>
                  </div>
                  <Link className="post-title mb-3" to="/blogdetails">
                    Modern Offices in The Best District in Town
                  </Link>
                  <Link to="/blogdetails" className="btn btn-link">
                    {" "}
                    Read More <i className="ti ti-arrow-up-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default BlogWrapper;
